import VideoJS from 'video.js';

import * as Controls from '../../ui/UIControlsNames';
import ccSVG from '../../ui/icons/cc.svg';

const SubtitlesButton = VideoJS.getComponent('SubtitlesButton');

const ccIcon = VideoJS.dom.createEl('span', {
    innerHTML: ccSVG,
    className: 'vjs-icon vjs-icon--cc',
}, {
    'aria-hidden': 'true'
});

class ASSubtitlesButton extends SubtitlesButton {
    constructor(player, options) {
        super(player, options);
        this.menuButton_.el_.appendChild(ccIcon);
    }

    buildCSSClass() {
        return `as-subtitles-button ${super.buildCSSClass()}`;
    }

    buildWrapperCSSClass() {
        return `as-subtitles-button-wrapper ${super.buildWrapperCSSClass()}`;
    }
}

VideoJS.registerComponent(Controls.SUBTITLES_BUTTON, ASSubtitlesButton);

export default ASSubtitlesButton;



// WEBPACK FOOTER //
// ./src/player/components/ASSubtitlesButton.js